module.exports = __webpack_public_path__ + "fonts/icomoon.edeec315.ttf";